import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import BgImg1 from "../../../images/case-studies/mdrouz/intro_back_1920.webp";
import Img1 from "../../../images/case-studies/mdrouz/intro_mob_md.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Introcase = () => {
    return (
        <div className="intro_case" style={{ backgroundImage: `url(${BgImg1})` }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="offset-xl-8 offset-lg-8">
                        <div className="intro_head">
                            <h2><span>Introduction</span></h2>
                            <p>Mdrouz is the result of TekRevol's commitment to transforming the traditional e-commerce landscape in the GCC region. Rooted in the client's branding guidelines, the app aimed to deliver an unparalleled shopping experience, seamlessly integrating diverse features to cater to the unique preferences and demands of the target audience.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="intro_img d-lg-none d-sm-block d-md-block d-xl-none d-xxl-none">
                        <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid"
                                />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Introcase